import EntityModel from '@/common/models/entity-model';
import TimelineMessageDataTableModel from './timeline-message-data-table-model';

export default class TimelineMessageDataModel extends EntityModel {
    hydrate({
        actions = [],
        links = [],
        tables = [],
        author = {},
        mentions = [],
    } = {}) {
        this.actions = actions;
        this.links = links;
        this.tables = tables.map(table => new TimelineMessageDataTableModel(table));
        this.author = author;
        this.mentions = mentions;
    }

    get hasActions() {
        return this.actions.length > 0;
    }

    get hasTables() {
        return this.tables.length > 0;
    }

    getAction(actionName) {
        return this.actions.find(({action}) => action === actionName);
    }

    /**
     * Some actions which has some custom logic
     */
    static ExtraDataActions = {
        editDispute: 'edit-dispute',
    };
}
